













































import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, watch} from "@vue/composition-api";
import OptionListItem from '@/views/Admin/Channels/ChannelManagementOptions/components/OptionListItem.vue';
import ToggleButton from '@/components/NEW-STRUCTURE/desktop/Admin/buttons/ToggleButton.vue';
import ToggleOptionListItem from '@/views/Admin/Channels/ChannelManagementOptions/components/ToggleOptionListItem.vue';

export default defineComponent({
    components: {
        OptionListItem,
        ToggleButton,
        ToggleOptionListItem,
    },
    props: {
    },
    setup(props, { root, emit }) {
        
        const store = root.$store;

        const notificationsOn: Ref<boolean> = ref(false);

        const channelTabs: ComputedRef<any> = computed(() => {
            return store.getters['Channels/getChannelsTabs'];
        });

        const handleChannelMembers = () => {
            const { CHANNEL_MEMBERS } = channelTabs.value;
            emit('changeManagementTab', CHANNEL_MEMBERS);
        }

        const handleInviteMembers = () => {
            emit('showInviteModal');
        }

        const handleBlockedUsers = () => {
            const { BANNED_MEMBERS } = channelTabs.value;
            emit('changeManagementTab', BANNED_MEMBERS);
        }

        const handleModeration = () => {
            const { MODERATION } = channelTabs.value;
            emit('changeManagementTab', MODERATION);
        }

        // TODO v2
        const handleToggleClick = (newValue) => {
            notificationsOn.value = newValue;
            console.log('handleToggleClick' , newValue);
        }

        // TODO v2
        onMounted(() => {
            // fetch notification status and assign it to notificationsOn
        });

        return {
            notificationsOn,
            handleBlockedUsers,
            handleChannelMembers,
            handleInviteMembers,
            handleModeration,
            handleToggleClick,
        };
    }
});
